import { LitElement, html, svg } from 'lit';

export class IconAlertSuccess16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Grønn sirkel med hakemerke</title><circle cx="8" cy="8" r="8" fill="currentColor" transform="rotate(180 8 8)"></circle><path fill="#fff" fill-rule="evenodd" d="M11.498 4.94a.75.75 0 0 1 .063 1.058l-4 4.5a.75.75 0 0 1-1.091.032l-2-2a.75.75 0 0 1 1.06-1.06l1.438 1.437 3.471-3.905a.75.75 0 0 1 1.06-.063Z" clip-rule="evenodd"></path></svg>`; }
}
if (!customElements.get('f-icon-alert-success16', IconAlertSuccess16)) {
  customElements.define('f-icon-alert-success16', IconAlertSuccess16);
}